module.exports = __webpack_public_path__ + "img/memo-pad.1af30b53.svg";